module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/app_google-efd523fa03b110da97f36d9b42e415ee.png";